import {iterChildren, getProp, JSX} from '@gongxigames/framework/core/fragments/BuilderY';
import {coreStore} from '@gongxigames/framework/core/globals';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {SpineComponentBaseProps} from './Spine';
import {SpineComponentBase} from './SpineComponentBase';

export function createSpineInstance(props: SpineComponentBaseProps): SpineComponentBase {
    const spineName = getProp(props.spine);
    const skeletonData = coreStore.resourceLoader.value!.getSpineSkeletonData(spineName);
    const updater = getUpdater(props);

    return new SpineComponentBase(skeletonData, updater);
}

export function setAnimation(props: SpineComponentBaseProps, instance: SpineComponentBase): void {
    const off = Store.effect(() => {
        const animation = getProp(props.animation)!;

        instance.setAnimation({
            animationName: animation.name,
            loop: animation.loop,
            skinName: animation.skin,
            trackIndex: animation.trackIndex,
            listeners: animation.listeners
        });
    });

    instance.on('destroyed', off);
}

export function handlePlayProp(props: SpineComponentBaseProps, instance: SpineComponentBase): void {
    const off = Store.effect(() => {
        const play = getProp(props.play);

        // Please do not simplify, we shouldn't do anything if the 'play' property is undefined
        if (play === true) {
            instance.start();
        } else if (play === false) {
            instance.stop();
        }
    });

    instance.on('destroyed', off);
}

export function setUpdater(props: SpineComponentBaseProps, instance: SpineComponentBase): void {
    const off = Store.effect(() => {
        const updater = getUpdater(props);
        const oldUpdateManager = instance.updateManager;

        if (oldUpdateManager) {
            oldUpdateManager.remove(instance);
        }

        updater.add(instance);
    });

    instance.on('destroyed', off);
}

export function replaceSlots(spine: SpineComponentBase, children: JSX.Element): void {
    const off = Store.effect(() => {
        const childrenArray = [...iterChildren(children)];

        spine.setAttachments(childrenArray);
    });

    spine.on('destroyed', off);
};

function getUpdater(props: SpineComponentBaseProps) {
    return getProp(props.updater) ?? coreStore.updateManager.value!;
}
